import { render, staticRenderFns } from "./WidgetBuilder.vue?vue&type=template&id=98e48500&scoped=true&"
import script from "./WidgetBuilder.vue?vue&type=script&lang=js&"
export * from "./WidgetBuilder.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBuilder.vue?vue&type=style&index=0&id=98e48500&lang=scss&scoped=true&"
import style1 from "./WidgetBuilder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e48500",
  null
  
)

export default component.exports